import { render, staticRenderFns } from "./company_settings.vue?vue&type=template&id=5227fccd"
import script from "./company_settings.vue?vue&type=script&lang=js"
export * from "./company_settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports